// 导入必要的函数和配置
import { sendRequest } from './api';
import { locale, region, lang } from './config';

// 将语言设置输出到控制台
console.log(lang, "lang");
console.log(locale,'locale');

// 获取行业类别的函数
export const fetchIndustries = async () => {
  try {
    // 发送一个 GET 请求到指定的端点，使用 locale 和 region 作为头信息
    const data = await sendRequest(
      'GET',
      '/api/plm/product/category-groups',
      null,
      { locale, region }
    );
    return data; // 返回获取的数据
  } catch (error) {
    console.error(error.message); // 记录发生的任何错误
  }
};

// 根据 ID 获取类型系列的函数
export const fetchTypeSeries = async id => {
  try {
    // 发送一个 GET 请求到指定的端点，使用给定的 ID，并使用 locale 和 region 作为头信息
    const data = await sendRequest(
      'GET',
      `/api/plm/product/category-groups/${id}`,
      null,
      { locale, region }
    );
    return data; // 返回获取的数据
  } catch (error) {
    console.error(error.message); // 记录发生的任何错误
  }
};

// 获取文件列表的函数
export const fetchFilesList = async params => {
  try {
    // 发送一个 GET 请求到指定的端点，使用传入的参数以及 locale 和 region 作为头信息
    const data = await sendRequest(
      'GET',
      '/api/plm/product/published-files',
      null,
      { ...params, locale, region }
    );
    return data; // 返回获取的数据
  } catch (error) {
    console.error(error.message); // 记录发生的任何错误
  }
};

// 获取搜索结果的函数
export const fetchSearchRes = async params => {
  try {
    // 发送一个 GET 请求到指定的端点，使用传入的参数以及 locale 和 region 作为头信息
    const data = await sendRequest(
      'GET',
      '/api/plm/website/product/published-files',
      null,
      { ...params, locale, region }
    );
    return data; // 返回获取的数据
  } catch (error) {
    console.error(error.message); // 记录发生的任何错误
  }
};

// 下载文件的函数
export const fetchFileDownload = async doc_id => {
  try {
    // 发送一个 GET 请求到指定的端点，使用给定的文档 ID，并包含详细信息作为头信息
    const data = await sendRequest(
      'GET',
      `/api/common/documents/${doc_id}`,
      null,
      { verbose: 100 }
    );
    return data; // 返回获取的数据
  } catch (error) {
    console.error(error.message); // 记录发生的任何错误
  }
};


export const yuqueDownload = async ({ group_login, book_slug, id }) => {
  try {
    const response = await sendRequest(
      'get',
      `https://poweris.inhand.online/api/yuque/download?group_login=${group_login}&book_slug=${book_slug}&id=${id}`,
      null,
      // {
      //   responseType: 'blob', // 添加这个以确保正确处理二进制数据
      //   // headers: {
      //   //   'Authorization': `Bearer 25d46497b2a5497e9a4b2e529141f8cf`,
      //   //   // 或者
      //   //   // 'token': token
      //   // }
      // }
    );
    return response;
  } catch (error) {
    console.error('下载文件失败:', error);
    throw error; // 向上传递错误以便于组件处理
  }
};
